Vue.component('register', require('./components/RegisterComponent.vue').default);
Vue.component('create-absence', require('./components/CreateAbsenceComponent.vue').default);
Vue.component('worked-time-index', require('./components/WorkedTimeIndexComponent.vue').default);
Vue.component('create-worked-time', require('./components/CreateWorkedTimeComponent.vue').default);
Vue.component('employer-worked-time-index', require('./components/EmployerWorkedTimeIndexComponent.vue').default);
Vue.component('create-sick-leave', require('./components/CreateSickLeaveComponent.vue').default);
Vue.component('destroy-sick-leave', require('./components/DestroySickLeaveComponent.vue').default);
Vue.component('employer-absence-index', require('./components/EmployerAbsenceIndexComponent.vue').default);
Vue.component('employer-sick-leave-index', require('./components/EmployerSickLeaveIndexComponent.vue').default);
Vue.component('notification-bell', require('./components/NotificationBellComponent.vue').default);
Vue.component('notification-index', require('./components/NotificationIndexComponent.vue').default);
Vue.component('send-new-mail', require('./components/SendNewMailComponent.vue').default);
Vue.component('create-edit-contract', require('./components/CreateEditContractComponent.vue').default);
Vue.component('create-company', require('./components/CreateCompanyComponent.vue').default);
Vue.component('employer-employees-index', require('./components/EmployerEmployeesIndex').default);

// Employer & Employee view
Vue.component('absence-calendar', require('./components/AbsenceCalendar').default);

// Calendar components
Vue.component('calendar-popup', require('./components/Calendar/Popup').default);
Vue.component('calendar-absence-object', require('./components/Calendar/AbsenceObject').default);
Vue.component('calendar-filters', require('./components/Calendar/Filters').default);
Vue.component('calendar-filter', require('./components/Calendar/Filter').default);
Vue.component('calendar-warning-popup', require('./components/Calendar/WarningPopup').default);

// Filter edit components
Vue.component('company-departments', require('./components/Company/Departments').default);
Vue.component('company-department', require('./components/Company/Department').default);
Vue.component('company-employees', require('./components/Company/Employees').default);
Vue.component('company-add-department', require('./components/Company/AddDepartment').default);
Vue.component('company-add-employee', require('./components/Company/AddEmployee').default);

// Declarability
Vue.component('declarability-overview', require('./components/DeclarabilityOverviewComponent').default);
Vue.component('declarability-status-update', require('./components/DeclarabilityStatusUpdateComponent').default);